import {useAppState} from "@/store";

export default function Layout({children}) {

    const {state} = useAppState()

    const pt = state.currentStep === 7 ? 'pt-[80px] lg:pt-[112px]' : 'pt-[112px] lg:pt-[140px]'

    return (
        <div className={"bg-light"}>
            <div className={`w-full max-w-[1440px] mx-auto px-[16px] lg:px-[56px] xl:px-[112px] ${pt}`}>
                {children}
            </div>
        </div>
    )
}
